import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

import PageTitle from '../controls/PageTitle'
import CommunityAccessControl from '../dooraccess/CommunityAccessControlContainer'

class CommunityDoorAccessPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
  }

  communityId() {
    return parseInt(this.props.match.params.communityId, 10)
  }

  render() {
    const communityId = this.communityId()

    return (
      <>
        <PageTitle title="Manage Door Access" />
        <Typography variant="h3">Manage Door Access</Typography>
        <CommunityAccessControl communityId={communityId} />
      </>
    )
  }
}

export default CommunityDoorAccessPage
